import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../lib/auth";
import { NATIVE_AUTH_URL_PREFIX } from "../lib/nativeSession";

const NATIVE_RETURN_PATH = "/auth/native-return";

export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { nav("/login", { replace: true }); return; }
    // Opened inside the native app's Safari sheet: hand the session back to the app.
    if (window.location.pathname === NATIVE_RETURN_PATH) {
      window.location.href = `${NATIVE_AUTH_URL_PREFIX}#session_id=${m[1]}`;
      return;
    }
    api.post("/auth/google", { session_id: decodeURIComponent(m[1]) })
      .then((r) => {
        setUser(r.data);
        window.history.replaceState({}, "", "/workspaces");
        nav("/workspaces", { replace: true });
      })
      .catch(() => nav("/login", { replace: true }));
  }, [nav, setUser]);

  if (window.location.pathname === NATIVE_RETURN_PATH) {
    const m = (window.location.hash || "").match(/session_id=([^&]+)/);
    return (
      <div className="m-loading-screen" data-testid="auth-native-return">
        <div className="m-loading-logo"><img src="/brand/metier-logo.png" alt="Métier" /></div>
        <p>Returning you to the Métier app…</p>
        {m && (
          <a className="m-btn-gold" href={`${NATIVE_AUTH_URL_PREFIX}#session_id=${m[1]}`} data-testid="auth-native-return-btn">
            Open Métier
          </a>
        )}
      </div>
    );
  }

  return (
    <div className="m-loading-screen" data-testid="auth-callback-loading">
      <div className="m-loading-logo"><img src="/brand/metier-logo.png" alt="Métier" /></div>
      <p>Signing you in…</p>
    </div>
  );
}
